var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"menu",staticClass:"user-menu"},[_c('AppDropdown',{attrs:{"close-on-select":"","valueKey":"dataCy","items":_vm.menuItems,"value":null,"placeholder":_vm.currentUser.account_id},on:{"select":_vm.clickMenuLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }